/**
 * Internal dependencies
 */
import {
    CURRENT_CLOUD_BACKUP_RECEIVE,
    CURRENT_CLOUD_BACKUP_REQUEST,
    CURRENT_CLOUD_BACKUP_REQUEST_SUCCESS,
    CURRENT_CLOUD_BACKUP_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import {getCurrentCloudBackup, requestingCurrentCloudBackup} from 'state/current-cloud-backup/selectors';

/**
 * [description]
 *
 * @param  {[type]}         [description]
 * @return {[type]}         [description]
 */
export const setCurrentCloudBackup = (backup) => {
    return {
        type: CURRENT_CLOUD_BACKUP_RECEIVE,
    };
};

/**
 * [description]
 *
 * @param  {[type]} ) [description]
 * @return {[type]}   [description]
 */
export const requestCurrentCloudBackup = () => (dispatch) => {
    dispatch({
        type: CURRENT_CLOUD_BACKUP_REQUEST,
    });

    return cscom
        .currentCloudBackup()
        .get()
        .then((backup) => {
            dispatch({
                type: CURRENT_CLOUD_BACKUP_REQUEST_SUCCESS,
            });
            dispatch({
                type: CURRENT_CLOUD_BACKUP_RECEIVE,
                payload: {
                    backup,
                },
            });

            return backup;
        })
        .catch((error) => {
            if (error == 'Error: Not Found') {
                dispatch({
                    type: CURRENT_CLOUD_BACKUP_REQUEST_SUCCESS,
                });
                return;
            }
            dispatch({
                type: CURRENT_CLOUD_BACKUP_REQUEST_FAILURE,
                error,
            });
        });
};

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestCurrentCloudBackupIfNotRequested = (...props) => async (dispatch, getState) => {
    
    const currentCloudBackup = getCurrentCloudBackup(getState());
    const requesting = requestingCurrentCloudBackup(getState());

    if (!currentCloudBackup && requesting == false) {
        return dispatch(requestCurrentCloudBackup(...props));
    }

    return currentCloudBackup;
}
